import React, {createContext, useContext, useState} from 'react';

const ContextGlobal = createContext();

export const useAuth = () => useContext(ContextGlobal);

export const ContextProvider = props => {
    const [direction, setDirection] = useState(true);

    const cambio = () =>{
        setDirection(!direction);
    
        setTimeout(() => {
            window.scroll(0,0);
            let ubicacion = window.location.pathname;
            let documento;

            let header = document.getElementById("header").className;
            if (header === "header_negro") {
                document.getElementById("header").className = "header_blanco";
                document.getElementById("imagen_header_2").className = "imagen_header invisible_header";
                document.getElementById("imagen_header_1").className = "imagen_header visible_header";
            }
        
            let activo = document.getElementsByClassName("activo_header");
            if (activo[0]) {
                activo[0].className = "titulo-header2";
            }
        
            if (ubicacion === "/") {
                documento = document.getElementById("inicio");
                documento.className = documento.className + " activo_header";
            } else if (ubicacion === "/portafolio") {
                documento = document.getElementById("portafolio");
                documento.className = documento.className + " activo_header";
            } else if (ubicacion === "/nosotros") {
                documento = document.getElementById("nosotros");
                documento.className = documento.className + " activo_header";
            } else if (ubicacion === "/contacto") {
                documento = document.getElementById("contacto");
                documento.className = documento.className + " activo_header";
            } else if (ubicacion.split("/")[1] === "servicios" || ubicacion.split("/")[1] === "servicio") {
                documento = document.getElementById("servicios");
                if (ubicacion.split("/").length >= 3) {
                    document.getElementById("header").className = "header_negro";
                    document.getElementById("imagen_header_2").className = "imagen_header visible_header";
                    document.getElementById("imagen_header_1").className = "imagen_header invisible_header";
                }
                documento.className = documento.className + " activo_header";
            }
        }, 700);
    }

    const value = {
        direction,
        cambio
    };

    return(
        <ContextGlobal.Provider value={value}>
            {props.children}
        </ContextGlobal.Provider>
    )
}